/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var expr = function () {
  var o = function (k, v, o, l) {
      for (o = o || {}, l = k.length; l--; o[k[l]] = v);
      return o;
    },
    $V0 = [1, 5],
    $V1 = [1, 10],
    $V2 = [1, 16],
    $V3 = [1, 24],
    $V4 = [1, 25],
    $V5 = [1, 26],
    $V6 = [1, 17],
    $V7 = [1, 18],
    $V8 = [1, 19],
    $V9 = [1, 20],
    $Va = [1, 23],
    $Vb = [5, 33, 39, 40],
    $Vc = [5, 7, 33, 39, 40],
    $Vd = [5, 7, 9, 33, 39, 40],
    $Ve = [5, 7, 9, 10, 12, 14, 15, 16, 17, 18, 19, 20, 22, 23, 33, 39, 40],
    $Vf = [1, 42],
    $Vg = [1, 43],
    $Vh = [5, 7, 9, 10, 12, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 26, 33, 39, 40],
    $Vi = [1, 44],
    $Vj = [1, 45],
    $Vk = [5, 7, 9, 10, 12, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 26, 27, 29, 33, 39, 40],
    $Vl = [5, 7, 9, 10, 12, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 26, 27, 29, 32, 33, 39, 40, 43],
    $Vm = [1, 66],
    $Vn = [1, 77],
    $Vo = [33, 39, 40];
  var parser = {
    trace: function trace() {},
    yy: {},
    symbols_: {
      error: 2,
      expression: 3,
      expr: 4,
      EOF: 5,
      and_expr: 6,
      OR: 7,
      not_expr: 8,
      AND: 9,
      NOT: 10,
      cmp_expr: 11,
      EQ: 12,
      arith_expr: 13,
      NE: 14,
      GT: 15,
      LT: 16,
      GE: 17,
      LE: 18,
      IN: 19,
      IS: 20,
      empty: 21,
      CT: 22,
      NOTCT: 23,
      ADD: 24,
      term: 25,
      SUB: 26,
      MUL: 27,
      factor: 28,
      DIV: 29,
      call: 30,
      primary: 31,
      LPAREN: 32,
      RPAREN: 33,
      expr_list: 34,
      atom: 35,
      attribute: 36,
      list: 37,
      LBRACKET: 38,
      RBRACKET: 39,
      COMMA: 40,
      custommetadata: 41,
      CUSTOMMETADATA: 42,
      DOTATTR: 43,
      identifier: 44,
      IDENTIFIER: 45,
      EMPTY: 46,
      NUMBER: 47,
      TRUE: 48,
      FALSE: 49,
      NULL: 50,
      STRING: 51,
      $accept: 0,
      $end: 1
    },
    terminals_: {
      2: 'error',
      5: 'EOF',
      7: 'OR',
      9: 'AND',
      10: 'NOT',
      12: 'EQ',
      14: 'NE',
      15: 'GT',
      16: 'LT',
      17: 'GE',
      18: 'LE',
      19: 'IN',
      20: 'IS',
      22: 'CT',
      23: 'NOTCT',
      24: 'ADD',
      26: 'SUB',
      27: 'MUL',
      29: 'DIV',
      32: 'LPAREN',
      33: 'RPAREN',
      38: 'LBRACKET',
      39: 'RBRACKET',
      40: 'COMMA',
      42: 'CUSTOMMETADATA',
      43: 'DOTATTR',
      45: 'IDENTIFIER',
      46: 'EMPTY',
      47: 'NUMBER',
      48: 'TRUE',
      49: 'FALSE',
      50: 'NULL',
      51: 'STRING'
    },
    productions_: [0, [3, 2], [4, 3], [4, 1], [6, 3], [6, 1], [8, 2], [8, 1], [11, 3], [11, 3], [11, 3], [11, 3], [11, 3], [11, 3], [11, 3], [11, 4], [11, 3], [11, 3], [11, 4], [11, 4], [11, 3], [11, 3], [11, 1], [13, 3], [13, 3], [13, 1], [25, 3], [25, 3], [25, 1], [28, 2], [28, 1], [30, 3], [30, 4], [30, 1], [31, 1], [31, 1], [31, 1], [31, 3], [37, 2], [37, 3], [34, 3], [34, 1], [41, 1], [36, 2], [44, 1], [21, 1], [35, 1], [35, 1], [35, 1], [35, 1], [35, 1], [35, 1], [35, 1]],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
      /* this == yyval */

      var $0 = $$.length - 1;
      switch (yystate) {
        case 1:
          return $$[$0 - 1];
          break;
        case 2:
          if ($$[$0] instanceof nodes.BoolOp && $$[$0].op === nodes.Op.Or) {
            this.$ = new nodes.BoolOp(nodes.Op.Or, [$$[$0 - 2]].concat($$[$0].operands));
          } else this.$ = new nodes.BoolOp(nodes.Op.Or, [$$[$0 - 2], $$[$0]]);
          break;
        case 3:
        case 5:
        case 7:
        case 22:
        case 25:
        case 28:
        case 30:
        case 33:
        case 34:
        case 35:
        case 36:
        case 50:
        case 51:
          this.$ = $$[$0];
          break;
        case 4:
          if ($$[$0] instanceof nodes.BoolOp && $$[$0].op === nodes.Op.And) {
            this.$ = new nodes.BoolOp(nodes.Op.And, [$$[$0 - 2]].concat($$[$0].operands));
          } else this.$ = new nodes.BoolOp(nodes.Op.And, [$$[$0 - 2], $$[$0]]);
          break;
        case 6:
          this.$ = new nodes.UnaryOp(nodes.Op.Not, $$[$0]);
          break;
        case 8:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Eq, $$[$0]);
          break;
        case 9:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Ne, $$[$0]);
          break;
        case 10:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Gt, $$[$0]);
          break;
        case 11:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Lt, $$[$0]);
          break;
        case 12:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Ge, $$[$0]);
          break;
        case 13:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Le, $$[$0]);
          break;
        case 14:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.In, $$[$0]);
          break;
        case 15:
          this.$ = new nodes.BinOp($$[$0 - 3], nodes.Op.NotIn, $$[$0]);
          break;
        case 16:
        case 17:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Is, $$[$0]);
          break;
        case 18:
        case 19:
          this.$ = new nodes.BinOp($$[$0 - 3], nodes.Op.IsNot, $$[$0]);
          break;
        case 20:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Ct, $$[$0]);
          break;
        case 21:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.NotCt, $$[$0]);
          break;
        case 23:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Add, $$[$0]);
          break;
        case 24:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Sub, $$[$0]);
          break;
        case 26:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Mul, $$[$0]);
          break;
        case 27:
          this.$ = new nodes.BinOp($$[$0 - 2], nodes.Op.Div, $$[$0]);
          break;
        case 29:
          if ($$[$0] instanceof nodes.Number) {
            this.$ = new nodes.Number(-$$[$0].value);
          } else {
            this.$ = new nodes.UnaryOp(nodes.Op.Sub, $$[$0]);
          }
          break;
        case 31:
          this.$ = new nodes.Call($$[$0 - 2], []);
          break;
        case 32:
          this.$ = new nodes.Call($$[$0 - 3], $$[$0 - 1]);
          break;
        case 37:
          this.$ = $$[$0 - 1];
          break;
        case 38:
          this.$ = new nodes.List([]);
          break;
        case 39:
          this.$ = new nodes.List($$[$0 - 1]);
          break;
        case 40:
          this.$ = $$[$0 - 2].concat($$[$0]);
          break;
        case 41:
          this.$ = [$$[$0]];
          break;
        case 42:
          this.$ = new surveys.CustomMetadata(yytext.substring(15).trim());
          break;
        case 43:
          this.$ = new nodes.Attribute($$[$0 - 1], yytext.substring(1).trim());
          break;
        case 44:
          this.$ = new nodes.Identifier(yytext);
          break;
        case 45:
          this.$ = new nodes.Empty();
          break;
        case 46:
          this.$ = new nodes.Number(Number(yytext));
          break;
        case 47:
          this.$ = new nodes.Bool(true);
          break;
        case 48:
          this.$ = new nodes.Bool(false);
          break;
        case 49:
          this.$ = new nodes.Null();
          break;
        case 52:
          this.$ = new nodes.String(yytext.substring(1, yytext.length - 1).replace(/\\[nt\\\"\']/g, function (m) {
            return {
              n: '\n',
              t: '\t'
            }[m[1]] || m[1];
          }).replace(/\\x[a-fA-F0-9]{2}/g, function (m) {
            return String.fromCharCode('0x' + m.substring(2));
          }).replace(/\\u[a-fA-F0-9]{4}/g, function (m) {
            return String.fromCharCode('0x' + m.substring(2));
          }));
          break;
      }
    },
    table: [{
      3: 1,
      4: 2,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      1: [3]
    }, {
      5: [1, 27]
    }, o($Vb, [2, 3], {
      7: [1, 28]
    }), o($Vc, [2, 5], {
      9: [1, 29]
    }), {
      8: 30,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vd, [2, 7], {
      10: [1, 38],
      12: [1, 31],
      14: [1, 32],
      15: [1, 33],
      16: [1, 34],
      17: [1, 35],
      18: [1, 36],
      19: [1, 37],
      20: [1, 39],
      22: [1, 40],
      23: [1, 41]
    }), o($Ve, [2, 22], {
      24: $Vf,
      26: $Vg
    }), o($Vh, [2, 25], {
      27: $Vi,
      29: $Vj
    }), o($Vk, [2, 28]), {
      26: $V1,
      28: 46,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vk, [2, 30]), o($Vk, [2, 33], {
      32: [1, 47],
      43: [1, 48]
    }), o($Vl, [2, 34]), o($Vl, [2, 35]), o($Vl, [2, 36]), {
      4: 49,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vl, [2, 46]), o($Vl, [2, 47]), o($Vl, [2, 48]), o($Vl, [2, 49]), o($Vl, [2, 50]), o($Vl, [2, 51]), o($Vl, [2, 52]), {
      4: 52,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      34: 51,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      39: [1, 50],
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vl, [2, 42]), o($Vl, [2, 44]), {
      1: [2, 1]
    }, {
      4: 53,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      6: 54,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vd, [2, 6]), {
      13: 55,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 56,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 57,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 58,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 59,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 60,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 61,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      19: [1, 62]
    }, {
      10: [1, 65],
      13: 63,
      21: 64,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      46: $Vm,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 67,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      13: 68,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      25: 69,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      25: 70,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      26: $V1,
      28: 71,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, {
      26: $V1,
      28: 72,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vk, [2, 29]), {
      4: 52,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      33: [1, 73],
      34: 74,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Vl, [2, 43]), {
      33: [1, 75]
    }, o($Vl, [2, 38]), {
      39: [1, 76],
      40: $Vn
    }, o($Vo, [2, 41]), o($Vb, [2, 2]), o($Vc, [2, 4]), o($Ve, [2, 8], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 9], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 10], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 11], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 12], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 13], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 14], {
      24: $Vf,
      26: $Vg
    }), {
      13: 78,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Ve, [2, 16], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 17]), {
      13: 79,
      21: 80,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      46: $Vm,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Ve, [2, 45]), o($Ve, [2, 20], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 21], {
      24: $Vf,
      26: $Vg
    }), o($Vh, [2, 23], {
      27: $Vi,
      29: $Vj
    }), o($Vh, [2, 24], {
      27: $Vi,
      29: $Vj
    }), o($Vk, [2, 26]), o($Vk, [2, 27]), o($Vk, [2, 31]), {
      33: [1, 81],
      40: $Vn
    }, o($Vl, [2, 37]), o($Vl, [2, 39]), {
      4: 82,
      6: 3,
      8: 4,
      10: $V0,
      11: 6,
      13: 7,
      25: 8,
      26: $V1,
      28: 9,
      30: 11,
      31: 12,
      32: $V2,
      35: 13,
      36: 14,
      37: 15,
      38: $V3,
      41: 21,
      42: $V4,
      44: 22,
      45: $V5,
      47: $V6,
      48: $V7,
      49: $V8,
      50: $V9,
      51: $Va
    }, o($Ve, [2, 15], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 18], {
      24: $Vf,
      26: $Vg
    }), o($Ve, [2, 19]), o($Vk, [2, 32]), o($Vo, [2, 40])],
    defaultActions: {
      27: [2, 1]
    },
    parseError: function parseError(str, hash) {
      if (hash.recoverable) {
        this.trace(str);
      } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
      }
    },
    parse: function parse(input) {
      var self = this,
        stack = [0],
        tstack = [],
        vstack = [null],
        lstack = [],
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;
      var args = lstack.slice.call(arguments, 1);
      var lexer = Object.create(this.lexer);
      var sharedState = {
        yy: {}
      };
      for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
          sharedState.yy[k] = this.yy[k];
        }
      }
      lexer.setInput(input, sharedState.yy);
      sharedState.yy.lexer = lexer;
      sharedState.yy.parser = this;
      if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
      }
      var yyloc = lexer.yylloc;
      lstack.push(yyloc);
      var ranges = lexer.options && lexer.options.ranges;
      if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
      } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
      }
      function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
      }
      _token_stack: var lex = function () {
        var token;
        token = lexer.lex() || EOF;
        if (typeof token !== 'number') {
          token = self.symbols_[token] || token;
        }
        return token;
      };
      var symbol,
        preErrorSymbol,
        state,
        action,
        a,
        r,
        yyval = {},
        p,
        len,
        newState,
        expected;
      while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
          action = this.defaultActions[state];
        } else {
          if (symbol === null || typeof symbol == 'undefined') {
            symbol = lex();
          }
          action = table[state] && table[state][symbol];
        }
        if (typeof action === 'undefined' || !action.length || !action[0]) {
          var errStr = '';
          expected = [];
          for (p in table[state]) {
            if (this.terminals_[p] && p > TERROR) {
              expected.push("'" + this.terminals_[p] + "'");
            }
          }
          if (lexer.showPosition) {
            errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ", got '" + (this.terminals_[symbol] || symbol) + "'";
          } else {
            errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : "'" + (this.terminals_[symbol] || symbol) + "'");
          }
          this.parseError(errStr, {
            text: lexer.match,
            token: this.terminals_[symbol] || symbol,
            line: lexer.yylineno,
            loc: yyloc,
            expected: expected
          });
        }
        if (action[0] instanceof Array && action.length > 1) {
          throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
          case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
              yyleng = lexer.yyleng;
              yytext = lexer.yytext;
              yylineno = lexer.yylineno;
              yyloc = lexer.yylloc;
              if (recovering > 0) {
                recovering--;
              }
            } else {
              symbol = preErrorSymbol;
              preErrorSymbol = null;
            }
            break;
          case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
              first_line: lstack[lstack.length - (len || 1)].first_line,
              last_line: lstack[lstack.length - 1].last_line,
              first_column: lstack[lstack.length - (len || 1)].first_column,
              last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
              yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
            }
            r = this.performAction.apply(yyval, [yytext, yyleng, yylineno, sharedState.yy, action[1], vstack, lstack].concat(args));
            if (typeof r !== 'undefined') {
              return r;
            }
            if (len) {
              stack = stack.slice(0, -1 * len * 2);
              vstack = vstack.slice(0, -1 * len);
              lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
          case 3:
            return true;
        }
      }
      return true;
    }
  };
  var nodes = require('./nodes');
  var surveys = require('./surveys');
  /* generated by jison-lex 0.3.4 */
  var lexer = function () {
    var lexer = {
      EOF: 1,
      parseError: function parseError(str, hash) {
        if (this.yy.parser) {
          this.yy.parser.parseError(str, hash);
        } else {
          throw new Error(str);
        }
      },
      // resets the lexer, sets new input
      setInput: function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
          first_line: 1,
          first_column: 0,
          last_line: 1,
          last_column: 0
        };
        if (this.options.ranges) {
          this.yylloc.range = [0, 0];
        }
        this.offset = 0;
        return this;
      },
      // consumes and returns one char from the input
      input: function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
          this.yylineno++;
          this.yylloc.last_line++;
        } else {
          this.yylloc.last_column++;
        }
        if (this.options.ranges) {
          this.yylloc.range[1]++;
        }
        this._input = this._input.slice(1);
        return ch;
      },
      // unshifts one char (or a string) into the input
      unput: function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);
        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);
        if (lines.length - 1) {
          this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;
        this.yylloc = {
          first_line: this.yylloc.first_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.first_column,
          last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
        };
        if (this.options.ranges) {
          this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
      },
      // When called from action, caches matched text and appends it on next action
      more: function () {
        this._more = true;
        return this;
      },
      // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
      reject: function () {
        if (this.options.backtrack_lexer) {
          this._backtrack = true;
        } else {
          return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
            text: '',
            token: null,
            line: this.yylineno
          });
        }
        return this;
      },
      // retain first n characters of the match
      less: function (n) {
        this.unput(this.match.slice(n));
      },
      // displays already matched input, i.e. for error messages
      pastInput: function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, '');
      },
      // displays upcoming input, i.e. for error messages
      upcomingInput: function () {
        var next = this.match;
        if (next.length < 20) {
          next += this._input.substr(0, 20 - next.length);
        }
        return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, '');
      },
      // displays the character position where the lexing error occurred, i.e. for error messages
      showPosition: function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join('-');
        return pre + this.upcomingInput() + '\n' + c + '^';
      },
      // test the lexed token: return FALSE when not a match, otherwise return token
      test_match: function (match, indexed_rule) {
        var token, lines, backup;
        if (this.options.backtrack_lexer) {
          // save context
          backup = {
            yylineno: this.yylineno,
            yylloc: {
              first_line: this.yylloc.first_line,
              last_line: this.last_line,
              first_column: this.yylloc.first_column,
              last_column: this.yylloc.last_column
            },
            yytext: this.yytext,
            match: this.match,
            matches: this.matches,
            matched: this.matched,
            yyleng: this.yyleng,
            offset: this.offset,
            _more: this._more,
            _input: this._input,
            yy: this.yy,
            conditionStack: this.conditionStack.slice(0),
            done: this.done
          };
          if (this.options.ranges) {
            backup.yylloc.range = this.yylloc.range.slice(0);
          }
        }
        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
          this.yylineno += lines.length;
        }
        this.yylloc = {
          first_line: this.yylloc.last_line,
          last_line: this.yylineno + 1,
          first_column: this.yylloc.last_column,
          last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
          this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
          this.done = false;
        }
        if (token) {
          return token;
        } else if (this._backtrack) {
          // recover context
          for (var k in backup) {
            this[k] = backup[k];
          }
          return false; // rule action called reject() implying the next rule should be tested instead.
        }

        return false;
      },
      // return next match in input
      next: function () {
        if (this.done) {
          return this.EOF;
        }
        if (!this._input) {
          this.done = true;
        }
        var token, match, tempMatch, index;
        if (!this._more) {
          this.yytext = '';
          this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
          tempMatch = this._input.match(this.rules[rules[i]]);
          if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
            match = tempMatch;
            index = i;
            if (this.options.backtrack_lexer) {
              token = this.test_match(tempMatch, rules[i]);
              if (token !== false) {
                return token;
              } else if (this._backtrack) {
                match = false;
                continue; // rule action called reject() implying a rule MISmatch.
              } else {
                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                return false;
              }
            } else if (!this.options.flex) {
              break;
            }
          }
        }
        if (match) {
          token = this.test_match(match, rules[index]);
          if (token !== false) {
            return token;
          }
          // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
          return false;
        }
        if (this._input === '') {
          return this.EOF;
        } else {
          return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
            text: '',
            token: null,
            line: this.yylineno
          });
        }
      },
      // return next match that has a token
      lex: function lex() {
        var r = this.next();
        if (r) {
          return r;
        } else {
          return this.lex();
        }
      },
      // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
      begin: function begin(condition) {
        this.conditionStack.push(condition);
      },
      // pop the previously active lexer condition state off the condition stack
      popState: function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
          return this.conditionStack.pop();
        } else {
          return this.conditionStack[0];
        }
      },
      // produce the lexer rule set which is active for the currently active lexer condition state
      _currentRules: function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
          return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
          return this.conditions['INITIAL'].rules;
        }
      },
      // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
      topState: function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
          return this.conditionStack[n];
        } else {
          return 'INITIAL';
        }
      },
      // alias for begin(condition)
      pushState: function pushState(condition) {
        this.begin(condition);
      },
      // return the number of states currently on the stack
      stateStackSize: function stateStackSize() {
        return this.conditionStack.length;
      },
      options: {
        'case-insensitive': true
      },
      performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
        var YYSTATE = YY_START;
        switch ($avoiding_name_collisions) {
          case 0 /* skip whitespace */:
            break;
          case 1:
            return 47;
            break;
          case 2:
            return 48;
            break;
          case 3:
            return 49;
            break;
          case 4:
            return 50;
            break;
          case 5:
            return 46;
            break;
          case 6:
            return 7;
            break;
          case 7:
            return 9;
            break;
          case 8:
            return 10;
            break;
          case 9:
            return 19;
            break;
          case 10:
            return 20;
            break;
          case 11:
            return 42;
            break;
          case 12:
            return 45;
            break;
          case 13:
            return 51;
            break;
          case 14:
            return 12;
            break;
          case 15:
            return 14;
            break;
          case 16:
            return 17;
            break;
          case 17:
            return 18;
            break;
          case 18:
            return 15;
            break;
          case 19:
            return 16;
            break;
          case 20:
            return 22;
            break;
          case 21:
            return 23;
            break;
          case 22:
            return 24;
            break;
          case 23:
            return 26;
            break;
          case 24:
            return 27;
            break;
          case 25:
            return 29;
            break;
          case 26:
            return 32;
            break;
          case 27:
            return 33;
            break;
          case 28:
            return 38;
            break;
          case 29:
            return 39;
            break;
          case 30:
            return 40;
            break;
          case 31:
            return 43;
            break;
          case 32:
            return 5;
            break;
          case 33:
            return 'INVALID';
            break;
        }
      },
      rules: [/^(?:\s+)/i, /^(?:[0-9]+\.?([0-9]+)?)/i, /^(?:TRUE\b)/i, /^(?:FALSE\b)/i, /^(?:NULL\b)/i, /^(?:EMPTY\b)/i, /^(?:OR\b)/i, /^(?:AND\b)/i, /^(?:NOT\b)/i, /^(?:IN\b)/i, /^(?:IS\b)/i, /^(?:(customMetadata\.)((.*)(?=\s[^a-zA-Z\d\s])|(.*)))/i, /^(?:[A-Za-z_][_A-Za-z0-9]*)/i, /^(?:"(?:[^\\"]|(?:\\.))*"|'(?:[^\\\']|(?:\\.))*')/i, /^(?:=)/i, /^(?:!=)/i, /^(?:>=)/i, /^(?:<=)/i, /^(?:>)/i, /^(?:<)/i, /^(?:~)/i, /^(?:!~)/i, /^(?:\+)/i, /^(?:-)/i, /^(?:\*)/i, /^(?:\/)/i, /^(?:\()/i, /^(?:\))/i, /^(?:\[)/i, /^(?:\])/i, /^(?:,)/i, /^(?:\.\s*[_A-Za-z0-9]+)/i, /^(?:$)/i, /^(?:.)/i],
      conditions: {
        INITIAL: {
          rules: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33],
          inclusive: true
        }
      }
    };
    return lexer;
  }();
  parser.lexer = lexer;
  function Parser() {
    this.yy = {};
  }
  Parser.prototype = parser;
  parser.Parser = Parser;
  return new Parser();
}();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
  exports.parser = expr;
  exports.Parser = expr.Parser;
  exports.parse = function () {
    return expr.parse.apply(expr, arguments);
  };
  exports.main = function commonjsMain(args) {
    if (!args[1]) {
      console.log('Usage: ' + args[0] + ' FILE');
      process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), 'utf8');
    return exports.parser.parse(source);
  };
  if (typeof module !== 'undefined' && require.main === module) {
    exports.main(process.argv.slice(1));
  }
}